/**
 * Gera CSV simples com separador `;` (compatível com Excel PT-BR) e
 * dispara download no navegador.
 */

function escape(value: unknown): string {
  if (value === null || value === undefined) return '';
  const str = String(value);
  if (str.includes(';') || str.includes('\n') || str.includes('"')) {
    return `"${str.replace(/"/g, '""')}"`;
  }
  return str;
}

export function downloadCsv<T>(
  filename: string,
  rows: T[],
  columns: Array<{ key: keyof T; label: string; format?: (row: T) => string | number | null | undefined }>,
) {
  const header = columns.map((c) => escape(c.label)).join(';');
  const body = rows
    .map((row) =>
      columns
        .map((c) => escape(c.format ? c.format(row) : (row as Record<string, unknown>)[c.key as string]))
        .join(';'),
    )
    .join('\n');

  const csv = `\uFEFF${header}\n${body}`;
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);

  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
